<template>
    <v-dialog max-width="80vw" v-model="dialog">
        <v-btn class="btn" color="light-blue lighten-4 blue-grey--text text--darken-3" slot="activator">
            <span>Ajouter un élément</span>
            <v-icon right>add_circle</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <h2>Ajout d'élément</h2>
            </v-card-title>
            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-text-field label="Entrez le nom de l'élément à ajouter" v-model="nom" prepend-icon="playlist_add" :rules="Rules"></v-text-field>
                    <v-btn class="mx-0 mt-4 btn_2" color="light-blue lighten-4 blue-grey--text text--darken-3" @click="submit" :loading="loading">Valider</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['liste'],
    data() {
        return {
            nom: '',
            Rules: [
                v => v.length <= 40 || '40 caractères maximum'
            ],
            loading: false,
            dialog: false,
        }
    },
    methods: {
        submit() {
            if(this.$refs.form.validate()) {
                const data = {
                    idListe: this.liste,
                    nom: this.nom
                }
                this.$store.dispatch('ajItem', data);
                this.nom = '';
                this.dialog = false;
                this.$emit('add');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .btn {
        height: 70px;
        border-radius: 10px;

        &_2 {
            width: 100%;
            border-radius: 5px;
        }
    }
</style>